import { createSelector } from 'reselect'
import { formatDateWithShortMonth } from '@offerzen/utils'
import { getEducation } from '../redux/modules/education'

const sortEducation = (a, b) => {
  if (a.graduation_year > b.graduation_year) return -1
  if (a.graduation_year < b.graduation_year) return 1
  if (a.start_year > b.start_year) return -1
  if (a.start_year < b.start_year) return 1
  return 0
}

const metadataLabel = ({ start_year: startYear, graduation_year: graduationYear }) => {
  let label = ''

  if (startYear) label += formatDateWithShortMonth(startYear, { includeDay: false })
  if (startYear && graduationYear) label += ' to '
  if (graduationYear) label += formatDateWithShortMonth(graduationYear, { includeDay: false })

  return label
}

const missingInformation = ({ isNew, degree, university, start_year: startYear, graduation_year: graduationYear }) =>
  !isNew && (!degree || !university || !startYear || !graduationYear)

export const educationList = createSelector([getEducation], ({ data }) => {
  return data
    .map(education => {
      let universityLabel = education.university
      if (education.degree) {
        universityLabel += ` - ${education.degree}`
      }
      return {
        ...education,
        formName: `education[ed-${education.id || education.tempId}]`,
        universityLabel,
        degreeLabel: education.degree,
        metadataLabel: metadataLabel(education),
        missingInformation: missingInformation(education),
        university: {
          label: education.university,
        },
        degree: {
          label: education.degree,
        },
        universitiesSearchResults: education.universitiesSearchResults.map(university => ({
          value: university.id,
          label: university.text,
        })),
        degreesSearchResults: education.degreesSearchResults.map(degree => ({
          value: degree.id,
          label: degree.text,
        })),
      }
    })
    .sort((a, b) => sortEducation(a, b))
})

export const anyRecordsMissingInformation = createSelector([getEducation], ({ data }) =>
  data.some(education => missingInformation(education)),
)

export const currentlyEditingFormNames = createSelector([getEducation], ({ data }) => {
  return data.filter(education => !!education.editing).map(education => `education[ed-${education.id || education.tempId}]`)
})

export const hasEducationRecords = createSelector([getEducation], ({ data }) => {
  return data.filter(education => !education.isNew).length > 0
})

export const isAddingNewEducation = createSelector([getEducation], ({ data }) => {
  return data.filter(education => education.isNew).length > 0
})
